import React, { useState } from "react";
import { Paper, Tabs, Tab} from "@material-ui/core";
import TabPanel from "./TabPanel";
import ViewHeadline from '@material-ui/icons/ViewHeadline';
import EditIcon from '@material-ui/icons/Edit';


function TabViewEdit(props) {
  const { role, viewComponent, AssignComponent, onChangeUrl, action } = props
  const [tabValue, setTabValue] = useState(action);

  const roles = [
    {value: 'Student', label: 'Staff/Students'},
    {value: 'Educator', label: 'Managers/Educators'},
  ];

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
    onChangeUrl(role, newValue);
  };

  return (
    <div className="tab-selection">
      <Paper square>
        <Tabs
          value={tabValue}
          indicatorColor="primary"
          textColor="primary"
          onChange={handleChange}
          aria-label="disabled tabs example"
          variant="fullWidth"
          scrollButtons="auto"
        >
          <Tab icon={<ViewHeadline />} label={`View ${roles.find(r => r.value === role).label}`} value={'View'}/>
          <Tab icon={<EditIcon />} label={`Assign ${roles.find(r => r.value === role).label}`} value={'Assign'}/>
        </Tabs>

        <TabPanel value={tabValue} index={'View'}>
          {viewComponent}
        </TabPanel>
        <TabPanel value={tabValue} index={'Assign'}>
          {AssignComponent}
        </TabPanel>
      </Paper>
    </div>
  );
}

export default TabViewEdit;